import i18next from 'i18next';

i18next.addResources('es', 'PDFScreen', {
  pdfNotFound: 'No se encontró el PDF'
});
